import React from 'react';

import { useSafeFocusEffect } from '@sg/garnish';

import { OrdersListWrapper } from '../../components';
import { useInStoreOrders } from '../../hooks';

export const InStoreOrders = () => {
  const {
    orders,
    fetchInitialOrders,
    isFetchingInitialOrders,
    isFetchingMoreOrders,
    canFetchMoreOrders,
    mostRecentOrder,
    fetchMoreOrders,
  } = useInStoreOrders();

  // Fetch orders on screen focus.
  useSafeFocusEffect(fetchInitialOrders);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <OrdersListWrapper
      canReorder={false}
      orders={orders}
      fetchMoreOrders={fetchMoreOrders}
      isFetchingInitialOrders={isFetchingInitialOrders}
      isFetchingMoreOrders={isFetchingMoreOrders}
      canFetchMoreOrders={canFetchMoreOrders}
      mostRecentOrder={mostRecentOrder}
    />
  );
};
